import React, { useEffect, useState } from "react";
import {
  StepperComponent,
  StepsDirective,
  StepDirective,
} from "@syncfusion/ej2-react-navigations";
import { useTranslation } from "react-i18next";
import axiosClient from "../Utils/axiosClient";
import { useNavigate } from "react-router-dom";
import { isNullOrUndefined } from "@syncfusion/ej2-base";

const Stepper = () => {
  const [currentStep, setCurrentStep] = useState(0);

  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchSteps = async () => {
      try {
        const response = await axiosClient.get("/dashboard/Stepper");
        let steps = 0;
        if ((await response.status) === 200) {
          const res = response.data;

          if (res.step1) steps = 1;
          if (!isNullOrUndefined(res.step2) && steps === 1) steps = 2;
          if (res.step3 > 0 && steps === 2) steps = 3;
          if (res.step4 > 0 && steps === 3) steps = 4;
          if (res.step5 > 0 && steps === 4) steps = 5;
          setCurrentStep(steps);
        }
      } catch (error) {}
    };
    fetchSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function getTooltipTemplate({ value }) {
    return (
      <span className="template-content">
        <span className="step-label">{value.text}</span>
      </span>
    );
  }
  function stepperIcon(val) {
    return currentStep > val ? "e-icons e-check" : "e-icons e-circle-info";
  }
  return (
    <>
      {currentStep !== 5 ? (
        <StepperComponent
          animation={{ enable: true, duration: 2000, delay: 500 }}
          showTooltip={true}
          tooltipTemplate={getTooltipTemplate}
          activeStep={currentStep || 0}
          stepClick={(args) => {
            if (args.activeStep === 1 || args.activeStep === 2)
              navigate(`/settings`);
            else if (args.activeStep === 3) navigate(`/accounts`);
            else if (args.activeStep === 4) navigate(`/contacts`);
            else if (args.activeStep === 5) navigate(`/sendmessage`);
            else {
            }
          }}
        >
          <StepsDirective>
            <StepDirective
              iconCss={stepperIcon(-1)}
              // text={t("Stepper.1")}
              //label={t("Confirm Email")}
              disabled
            />
            <StepDirective
              iconCss={stepperIcon(0)}
              text={t("Stepper.1")}
              label={t("Confirm Email")}
            />
            <StepDirective
              iconCss={stepperIcon(1)}
              text={t("Stepper.2")}
              label={t("Fblogin")}
            />
            <StepDirective
              iconCss={stepperIcon(2)}
              text={t("Stepper.3")}
              label={t("AddAccount")}
            />
            <StepDirective
              iconCss={stepperIcon(3)}
              text={t("Stepper.4")}
              label={t("AddContact")}
            />
            <StepDirective
              iconCss={stepperIcon(4)}
              text={t("Stepper.5")}
              label={t("SendFirstMessage")}
            />
          </StepsDirective>
        </StepperComponent>
      ) : (
        <></>
      )}
    </>
  );
};

export default Stepper;
